import { DOCUMENTS } from '@js/lib/constants/documents';

export const isTimeLimitOKForDigitalScreenShot = ({ cardType, digitalDLExpired = true } = {}) => {
  if (cardType !== DOCUMENTS.DIGITAL_DRIVER_LICENCE.cardType) {
    return true;
  }
  return !digitalDLExpired;
};
